import { useFormikContext } from "formik";
import { StudentProfileForm } from "../schemas";
import {
  ParentGuardianSection,
  ParentGuardianSectionProps,
} from "./ParentGuardianSection";

// Create-student usage of ParentGuardianSection: supplies the live student name
// from the surrounding Formik so a new guardian chip reads "Parent of {student}".
export function StudentGuardianSection(
  props: Omit<ParentGuardianSectionProps, "studentName">
) {
  const { values } = useFormikContext<StudentProfileForm>();
  const studentName = [values.first_name, values.last_name]
    .filter(Boolean)
    .join(" ");
  return <ParentGuardianSection {...props} studentName={studentName} />;
}
